import * as React from 'react';
import { TabsProps, TabsState, Tabs, Tab } from '../Tabs';
import { FirstTab } from './FirstTab';
import CongressTab from './CongressTab';
import AggregateTab from './AggregateTab';
import BenchmarkingTab from './BenchmarkingTab';
import MethodologyTab from './MethodologyTab';
import { isAgg } from '../../Common/Helpers';
import { FilterUserSpendingReportState, FilterAction } from '../../../interface/MyInterfaces';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';

class SpendingReportTabPanel extends React.Component<FilterUserSpendingReportState, TabsState> {
    getAggregateTab(aggregate) {
        if (aggregate)
            return (
                <Tab iconClassName={'fa fa-headphones'}
                    linkClassName={'custom-link'}
                    tabName="Aggregate Report"
                    handleTabClickFromParent={this.props.handleTabClickFromParent}
                >
                    <AggregateTab
                        SpendingReport_AggTab={this.props.SpendingReportState.SpendingReport_AggTab}
                        SpendingEmployeeChart_Data={this.props.SpendingReportState.SpendingEmployeeChart_Data_Agg}
                        SpendingEmployeeChart_Years={this.props.SpendingReportState.SpendingEmployeeChart_Years_Agg}
                        SpendingEmployeeAgencyChart_Data={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data_Agg}
                        FilterState={this.props.FilterState}
                        UserState={this.props.UserState}
                        SpendingReportConf={this.props.SpendingReportState.SpendingReportConf}
                        SpendingEmployeeChart_Aggregate={this.props.SpendingReportState.SpendingEmployeeChart_Aggregate}
                        SpendingEmployeeAgencyChart_Aggregate={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Aggregate}
                        SpendingExpenditureMap_Aggregate={this.props.SpendingReportState.SpendingExpenditureMap_Aggregate}
                        USStateList={this.props.SpendingReportState.USStateList}

                    />
                </Tab>
            )
        else return <span></span>
    }
    render() {
        var aggregate = this.props.FilterState.aggregate;
        
        return (
            <Tabs>
                <Tab
                    handleTabClickFromParent={this.props.handleTabClickFromParent}
                    iconClassName={'fa fa-headphones'}
                    linkClassName={'custom-link tab1'}
                    tabName="Spending Report"
                    arialabel="Opening spending report tab">
                    <FirstTab
                        SpendingReport_Tab1={this.props.SpendingReportState.SpendingReport_Tab1}
                        SpendingEmployeeChart_Data={this.props.SpendingReportState.SpendingEmployeeChart_Data}
                        SpendingEmployeeChart_Years={this.props.SpendingReportState.SpendingEmployeeChart_Years}
                        SpendingEmployeeAgencyChart_Data={this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data}
                        USStateList={this.props.SpendingReportState.USStateList}
                        FilterState={this.props.FilterState}
                        UserState={this.props.UserState}
                        SpendingReportConf={this.props.SpendingReportState.SpendingReportConf}
                        SpendingEmployeeAgencyChart={this.props.SpendingReportState.SpendingEmployeeAgencyChart}
                        SpendingExpenditureMap={this.props.SpendingReportState.SpendingExpenditureMap}
                        SpendingTotalByFips={this.props.SpendingReportState.SpendingTotalByFips}
                    />
                </Tab>
                <Tab
                    handleTabClickFromParent={this.props.handleTabClickFromParent}
                    iconClassName={'fa fa-headphones'}
                    linkClassName={'custom-link tab2'}
                    tabName="Congressional District Map"
                    arialabel="Opening congressional district map tab">
                    <CongressTab
                        SpendingReport_Tab2={this.props.SpendingReportState.SpendingReport_Tab2}
                        FilterState={this.props.FilterState}
                        UserState={this.props.UserState}
                        USStateList={this.props.SpendingReportState.USStateList}
                        SpendingReportConf={this.props.SpendingReportState.SpendingReportConf}
                        SpendingCongressMap={this.props.SpendingReportState.SpendingCongressMap}
                        SpendingTotalByFips={this.props.SpendingReportState.SpendingTotalByFips}
                    />
                </Tab>
                <Tab
                    handleTabClickFromParent={this.props.handleTabClickFromParent}
                    iconClassName={'fa fa-headphones'}
                    linkClassName={'custom-link tab3'}
                    tabName="Benchmarking"
                    arialabel="Opening benchmarking tab"
                    shouldShow={!isAgg(this.props.UserState && this.props.UserState.report_display_id)}//if agg report then remove benchmarking tab
                >
                    <BenchmarkingTab
                        SpendingReport_Tab3={this.props.SpendingReportState.SpendingReport_Tab3}
                        FilterState={this.props.FilterState}
                        UserState={this.props.UserState}
                        SpendingReportConf={this.props.SpendingReportState.SpendingReportConf}
                        SpendingSummaryTable={this.props.SpendingReportState.SpendingSummaryTable}
                        Top8CSV={this.props.SpendingReportState.Top8CSV}
                        SpendingEmployeeTable={this.props.SpendingReportState.SpendingEmployeeTable}
                        SpendingEmployeeAgencyTable={this.props.SpendingReportState.SpendingEmployeeAgencyTable}
                        SpendingExpenditureTable={this.props.SpendingReportState.SpendingExpenditureTable}
                        SpendingExpenditureTable2={this.props.SpendingReportState.SpendingExpenditureTable2}
                        SpendingInStateExpenditureBoxPlot={this.props.SpendingReportState.SpendingInStateExpenditureBoxPlot}
                        SpendingTotalByFips={this.props.SpendingReportState.SpendingTotalByFips}
                        SpendingEmployeeAgencyChart={this.props.SpendingReportState.SpendingEmployeeAgencyChart}
                        SpendingEmployeeChart={this.props.SpendingReportState.SpendingEmployeeChart}/>
                </Tab>
                {this.getAggregateTab(aggregate)}
                <Tab
                    handleTabClickFromParent={this.props.handleTabClickFromParent}
                    iconClassName={'fa fa-headphones'}
                    linkClassName={'custom-link tab4'}
                    arialabel="Opening methodology tab"
                    tabName="Methodology">
                    <MethodologyTab
                        FilterState={this.props.FilterState}
                        UserState={this.props.UserState}
                        SpendingReportConf={this.props.SpendingReportState.SpendingReportConf}
                    />

                </Tab>
            </Tabs>

        );
    }
}
const mapStateToProps = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    UserState: state.userProperties,
    SpendingReportState: state.spendingReportProperties
});

export default connect(
    mapStateToProps,
    null
)(SpendingReportTabPanel);